<script setup lang="ts">
import { useFlowStore } from '@/stores/flow';

const flow = useFlowStore();

function goToLearner() {
  window.location.href = '/learner/';
}
</script>

<template>
  <section class="screen">
    <div class="ok-mark" aria-hidden="true">
      <svg viewBox="0 0 64 64" width="56" height="56">
        <circle cx="32" cy="32" r="28" fill="#a4d65c" />
        <path
          d="M18 33 L28 43 L46 24"
          fill="none"
          stroke="#2a1b0e"
          stroke-width="4.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <h1 class="title">You're all set.</h1>

    <div v-if="flow.productNames.length" class="unlocked">
      <ul class="product-list">
        <li v-for="name in flow.productNames" :key="name">
          <span class="bullet" aria-hidden="true">●</span>
          <span>{{ name }}</span>
        </li>
      </ul>
      <div class="account">
        on
        <strong>
          {{ flow.user?.userName || (flow.user?.fName + ' ' + flow.user?.lName).trim() || 'your account' }}
        </strong>
      </div>
    </div>

    <p class="lede">
      The course is now on your account. Open your dashboard to start it any
      time.
    </p>

    <div class="actions">
      <button class="btn btn-primary btn-block" type="button" @click="goToLearner">
        Open my dashboard →
      </button>
    </div>
  </section>
</template>

<style scoped>
.screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.ok-mark {
  margin-bottom: 1.25rem;
}

.title {
  font-family: 'Fraunces', Georgia, serif;
  font-size: clamp(1.7rem, 3vw, 2.2rem);
  letter-spacing: -0.02em;
  color: var(--coco-900);
  margin: 0 0 1rem;
  font-weight: 500;
  font-variation-settings: 'SOFT' 50, 'opsz' 96;
}

.unlocked {
  background: linear-gradient(135deg, var(--lime-100), var(--lime-50));
  border: 1px solid var(--lime-200);
  border-radius: 12px;
  padding: 0.85rem 1rem;
  margin-bottom: 1.25rem;
  width: 100%;
}
.product-list {
  list-style: none;
  padding: 0;
  margin: 0 0 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}
.product-list li {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-weight: 500;
  color: var(--coco-900);
}
.bullet { color: var(--lime-600); font-size: 0.7rem; }
.account {
  font-size: 0.88rem;
  color: var(--coco-700);
}

.lede {
  margin: 0 0 1.5rem;
  color: var(--ink-soft);
  line-height: 1.55;
  max-width: 32em;
}

.actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
</style>
